import { render, staticRenderFns } from "./PreviousInstituteList.vue?vue&type=template&id=7459e3dc&scoped=true"
import script from "./PreviousInstituteList.vue?vue&type=script&lang=js"
export * from "./PreviousInstituteList.vue?vue&type=script&lang=js"
import style0 from "./PreviousInstituteList.vue?vue&type=style&index=0&id=7459e3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7459e3dc",
  null
  
)

export default component.exports